import Vue from "vue";
import ObjectStorageImageuploader from "./ObjectStorageImageuploader.vue";

import {Cropper, CircleStencil} from 'vue-advanced-cropper';


export default class ImageUploader {
    static init() {
        let boxes = document.querySelectorAll('.asd-image-uploader');

        Vue.use(Cropper);
        Vue.use(CircleStencil);

        boxes.forEach(x => {
            let data = x.getAttribute('data-data');
            if (data === undefined) {
                console.log('Cannot instantiate: empty data', x);
            }
            let realData;
            try {
                realData = JSON.parse(data);
            }
            catch (e) {
                console.log('Cannot parse raw data', data, x);
                return;
            }
            let component = Vue.extend(ObjectStorageImageuploader);
            new component({
                el: x,
                propsData: realData,
            })
        })
    }
}
